<!--
/**
  钱包余额调整申请管理列表
*/
-->
<template>
  <scroll-layout>
    <template #header>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="wallet-adjust-apply-main">
      <ykc-table
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        title="钱包余额调整申请列表"
        operateFixedType="right"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          direct="flex-end"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageIndex"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { code } from '@/utils';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { walletAdjustApply } from '@/service/apis';

  export default {
    name: 'WalletAdjustApplyList',

    data() {
      return {
        tableData: [],
        tableColumns: [
          { label: '申请编号', prop: 'applyNo', minWidth: '200px', fixed: true },
          {
            label: '钱包类型',
            prop: 'walletType',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                const walletTypeMap = {
                  1: '个人钱包',
                  2: '企业钱包',
                };
                return <span>{walletTypeMap[row.walletType] || '未知'}</span>;
              },
            },
          },
          { label: '调整原因', prop: 'adjustReason', minWidth: '200px' },
          {
            label: '调整类型',
            prop: 'adjustType',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                const adjustTypeMap = {
                  1: '充值',
                  2: '扣款',
                };
                return <span>{adjustTypeMap[row.adjustType] || '未知'}</span>;
              },
            },
          },
          { label: '调整金额', prop: 'adjustAmount', minWidth: '100px' },
          {
            label: '调整对象',
            prop: 'adjustObject',
            minWidth: '150px',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.walletType === 1 ? row.userAccount : row.orgCode}</span>;
              },
            },
          },
          { label: '申请人', prop: 'applyBy', minWidth: '100px' },
          { label: '申请时间', prop: 'applyTime', minWidth: '150px' },
          { label: '申请备注', prop: 'applyRemark', minWidth: '200px' },
          { label: '审核人', prop: 'auditBy', minWidth: '100px' },
          { label: '审核时间', prop: 'auditTime', minWidth: '150px' },
          {
            label: '审核状态',
            prop: 'status',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                const statusMap = {
                  1: '待审核',
                  2: '审核通过',
                  3: '审核拒绝',
                };
                return <span>{statusMap[row.status] || '未知'}</span>;
              },
            },
          },
        ],
        tableOperateButtons: [
          {
            enabled: () => code('finance:walletAdjust:list:pass'),
            render: (h, data, { row }) =>
              row.status === 1 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.auditStatus(row, 1);
                  }}>
                  通过
                </ykc-button>
              ) : null,
          },
          {
            enabled: () => code('finance:walletAdjust:list:reject'),
            render: (h, data, { row }) =>
              row.status === 1 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.auditStatus(row, 2);
                  }}>
                  拒绝
                </ykc-button>
              ) : null,
          },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          applyNo: '',
          adjustObject: '',
          applyBy: '',
          auditBy: '',
          status: '',
          applyTime: [],
          applyTimeStart: '',
          applyTimeEnd: '',
        },
        statusData: [
          { id: 1, name: '待审核' },
          { id: 2, name: '审核通过' },
          { id: 3, name: '审核拒绝' },
        ],
      };
    },
    created() {
      this.searchTableList();
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'applyNo',
            label: '申请单编号',
            placeholder: '请输入申请单编号',
          },
          {
            comName: 'YkcInput',
            key: 'adjustObject',
            label: '调整对象',
            placeholder: '请输入用户账号/企业编号',
          },
          {
            comName: 'YkcInput',
            key: 'applyBy',
            label: '申请人',
            placeholder: '请输入申请人',
          },
          {
            comName: 'YkcInput',
            key: 'auditBy',
            label: '审核人',
            placeholder: '请输入审核人',
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '审核状态',
            placeholder: '请选择审核状态',
            data: this.statusData,
          },
          {
            comName: 'YkcDatePicker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            key: 'applyTime',
            label: '申请时间',
          },
        ];
      },
    },
    methods: {
      /** 钱包余额调整申请审核 */
      auditStatus(row, auditResult) {
        const txt = auditResult === 1 ? '通过' : '拒绝';
        YkcDialog({
          showTitle: false,
          showFooter: true,
          dialogType: 'feedback',
          desc: `是否确定${txt}该钱包余额调整申请？`,
          onCancel: dialogDone => {
            dialogDone(); // 隐藏弹窗
          },
          onConfirm: dialogDone => {
            walletAdjustApply.audit({ id: row.id, auditResult }).then(res => {
              dialogDone(); // 隐藏弹窗
              this.$message.success('操作成功');
              this.searchTableList();
            });
          },
        });
      },
      /** 根据条件查询数据 */
      searchTableList() {
        const params = {
          ...this.searchParams,
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        walletAdjustApply.list(params).then(res => {
          this.tableData = res?.records || [];
          this.pageInfo.total = res?.total || 0;
        });
      },
      /**
       * @desc 点击查询按钮
       * */
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, form);
        if (form.applyTime && form.applyTime.length > 0) {
          [this.searchParams.applyTimeStart, this.searchParams.applyTimeEnd] = form.applyTime;
        }
        this.searchTableList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        this.searchParams.applyTimeStart = '';
        this.searchParams.applyTimeEnd = '';
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .wallet-adjust-apply-main {
    padding: 20px;
  }
</style>
